import { useElitePlansLanding } from '../ElitePlansLandingContext'
import { ELITE_PLANS_ELITE_PRIME_TAB_ID } from '../constants/planIds'
import { ELITE_PRIME_FEATURES_ELITE_BUNDLE_LABEL } from '../constants/copy'
import { ElitePlansFeatureGrid } from './ElitePlansFeatureGrid'
import { ElitePlansSectionSeparator } from './ElitePlansSectionSeparator'

export function ElitePlansFeaturesSection({
  eliteBundleLabel = ELITE_PRIME_FEATURES_ELITE_BUNDLE_LABEL
}: {
  eliteBundleLabel?: string
} = {}) {
  const { activeTab } = useElitePlansLanding()
  const isElitePrime = activeTab.id === ELITE_PLANS_ELITE_PRIME_TAB_ID
  const eliteFeatures = activeTab.featuresAfterCompare ?? []

  return (
    <>
      <ElitePlansSectionSeparator />
      <ElitePlansFeatureGrid
        config={{
          titleLine1: activeTab.featuresTitle.line1,
          titleLine2: activeTab.featuresTitle.line2,
          features: activeTab.features,
          planId: activeTab.id,
          benefitSheetVariant: isElitePrime ? 'elitePrime' : 'elite'
        }}
      />
      {isElitePrime && eliteFeatures.length > 0 ? (
        <div className='mt-12'>
          <div className='mb-8 px-6 text-sm leading-[14px] text-grey40'>
            {eliteBundleLabel}
          </div>
          <ElitePlansFeatureGrid
            config={{
              features: eliteFeatures,
              planId: activeTab.id,
              benefitSheetVariant: 'elite'
            }}
          />
        </div>
      ) : null}
    </>
  )
}
